<template>
  <footer class="footer-agreement">
    <div class="logo-footer"></div>
    <div class="agreement-container">
      <input type="checkbox" id="agreement" v-model="agreement">
      <label for="agreement" class="agreement">
        Нажимая на кнопку “Продолжить” Вы принимаете <a href="/privacy" target="_blank">Условия
          использования сервиса “Финсайт”</a>, даете
        <a href="/privacy" target="_blank">согласие на обработку своих персональных
          данных и соглашаетесь с условиями политики конфиденциальности</a>
      </label>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    value: String
  },
  data: () => {
    return {
      agreement: true,
    }
  },
  watch: {
    agreement: function () {
      this.error = false;
      this.$emit('setAgree', this.agreement)
    },
  },
}
</script>
<style scoped lang="scss">
footer.footer-agreement {
  margin: 0 auto 26px;
  max-width: 816px;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  position: relative;
  align-items: center;
  font-family: 'Circe';
  font-weight: 400;
  font-size: 10px;
  line-height: 140%;
  color: #828282;

  .logo-footer {
    background-image: url('../../../assets/img/logo-footer-desk.svg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 85px;
    height: 26px;
    margin-bottom: 22px;
  }

  a {
    color: #2F80ED;
    font-weight: 400;
  }

  .agreement-container {
    display: flex;
    position: relative;
    width: 95%;
  }

  .agreement-container input[type="checkbox"] {
    display: none;
  }

  .agreement-container label {
    position: relative;
    padding-left: 15px;
    margin-left: 0;
    cursor: pointer;
    text-align: center;
    margin: auto;
  }

  .agreement-container label:before {
    content: '';
    display: block;
    width: 11px;
    height: 11px;
    box-sizing: border-box;
    border: 0.5px solid #828282;
    position: absolute;
    top: 0px;
    left: 0px;
    cursor: pointer;
  }

  .agreement-container label:after {
    content: '';
    display: none;
    width: 7px;
    height: 7px;
    background: #22B491;
    top: 2px;
    left: 2px;
    position: absolute;
  }

  .agreement-container input[type="checkbox"]:checked+label:after {
    display: block;
  }

  .agreement {
    font-size: 10px;
    line-height: 14px;
    font-weight: normal;
    color: #828282;
    margin-bottom: 0;
  }
}


@media screen and (max-width: 650px) {
  footer.footer-agreement {
    width: 288px;
    margin: 30px auto 24px;

    .logo-footer {
      background-image: url('../../../assets/img/logo-footer-mob.svg');
      width: 65px;
      height: 20px;
      margin-bottom: 10px;
    }

    .agreement-container {
      width: 100%;
    }

    .agreement-container label {
      padding-left: 5px;
    }

    .agreement {
      font-size: 8px;
      line-height: 11px;
    }

    .agreement-container label:before {
      width: 9px;
      height: 9px;
    }

    .agreement-container label:after {
      width: 5px;
      height: 5px;
    }
  }


}
</style>
